import React from "react";

function SvgIcMapPoi104(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M22 15v6.99h-3V15h3zm-9 0v6.99h-3V15h3zm10-1.774v9.759H9v-9.759h14zm-1-7.223a1 1 0 010 2H10a1 1 0 010-2h12zm3 17V8.985H7v14.018a1.999 1.999 0 00-1.999 1.982H26.999A2 2 0 0025 23.003z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi104;
